import { HoursType } from '@app/shared/types/enums/hours-type';
import { TimePickerValue } from '@app/shared/types/models/shared/time-picker-value';

/** Daily from/to of a Range report (same shape as the shared series daily range). */
export interface TimeRangeModel {
  from: TimePickerValue;
  to: TimePickerValue;
}

/** Company → Project → Task → Location chain edited by the project/task selector. */
export interface ProjectTaskModel {
  company: string | null;
  project: string | null;
  task: string | null;
  location: string | null;
}

/** Per hour-type durations of a `Manual` hours-type report (manual-hours dialog only). */
export interface ManualDurationsModel {
  standardHoursDuration: TimePickerValue;
  bankHoursDuration: TimePickerValue;
  overtime50Duration: TimePickerValue;
  overtime100Duration: TimePickerValue;
}

export type ManualDurationKey = keyof ManualDurationsModel;

/** Plain Signal Forms model of the work-time report dialogs; every section exists from the start. */
export interface TimeReportFormModel {
  /** Report owner chosen by a time-report admin (create only). */
  userId: string | null;
  userName: string;
  date: Date | null;
  manualTime: TimePickerValue;
  timeRange: TimeRangeModel;
  projectTask: ProjectTaskModel;
  hourType: HoursType | null;
  comment: string;
  manualDurations: ManualDurationsModel;
}

export const MANUAL_DURATION_KEYS: readonly ManualDurationKey[] = [
  'standardHoursDuration',
  'bankHoursDuration',
  'overtime50Duration',
  'overtime100Duration'
];

export const MINUTE_STEPS: number[] = [1, 5, 10, 15];

export function timeToSeconds(value: TimePickerValue): number {
  return value.hours * 3600 + value.minutes * 60;
}

export function manualDurationsTotalSeconds(durations: ManualDurationsModel): number {
  return MANUAL_DURATION_KEYS.reduce((sum, key) => sum + timeToSeconds(durations[key]), 0);
}
